document.addEventListener("DOMContentLoaded", function() {
  var skipLink = document.querySelector('.skip-to-description');
  var targetSection = document.getElementById('TabsDescription');

  if (skipLink !== null) {
    skipLink.addEventListener('click', function (event) {
      event.preventDefault();
      var scrollHeight = targetSection.offsetTop - 145;
      
      window.scrollTo({
        top: scrollHeight,
        behavior: 'smooth'
      });
    });
  }
});
